import cssifyObject from 'css-in-js-utils/lib/cssifyObject';

export default function cssifyFontFace(fontFace) {
  return '@font-face{' + cssifyObject(fontFace) + '}';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/fela/es/cssifyFontFace.js
// module id = 1085
// module chunks = 0